// extracted by mini-css-extract-plugin
export var dividerWrapper = "ArticleDivider-module--dividerWrapper--3UMtN";
export var divider = "ArticleDivider-module--divider--1cSp7";